import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _CompositeBarItemController;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { makeObservable, observable, runInAction } from "mobx";
import { createRef } from "react";
export let CompositeBarItemController = (_class = (_CompositeBarItemController = class CompositeBarItemController {
  constructor() {
    _defineProperty(this, "itemRef", /*#__PURE__*/createRef());
    /**
     * Whether this item is disabled
     * @private
     */
    _initializerDefineProperty(this, "_disabled", _descriptor, this);
    /**
     * Whether this item is collapsed
     * @private
     */
    _initializerDefineProperty(this, "_collapsed", _descriptor2, this);
    /**
     * Whether this item is active
     * @protected
     */
    _initializerDefineProperty(this, "_active", _descriptor3, this);
    /**
     * Whether this item is pinned, if item is pinned it will be always visible on screen.
     * @private
     */
    _initializerDefineProperty(this, "_pinned", _descriptor4, this);
    /**
     * Whether this item is visible on the screen.
     * @private
     */
    _initializerDefineProperty(this, "_visible", _descriptor5, this);
    makeObservable(this);
  }
  get id() {
    return CompositeBarItemController.id;
  }
  /**
   * Gets the {@link this._disabled}
   */
  get disabled() {
    return this._disabled;
  }

  /**
   * Sets the {@link this._disabled}
   * @param value
   */
  set disabled(value) {
    this._disabled = value;
  }
  /**
   * Gets the {@this._collapsed}
   */
  get collapsed() {
    return this._collapsed;
  }

  /**
   * Sets the {@this._collapsed}
   */
  set collapsed(value) {
    this._collapsed = value;
  }
  /**
   * Gets the {@link this._active}
   */
  get active() {
    return !this.disabled && this._active;
  }
  /**
   * Gets the {@link this._pinned}
   */
  get pinned() {
    return this._pinned;
  }

  /**
   * Sets the {@link this._pinned}
   */
  set pinned(value) {
    this._pinned = value;
  }
  /**
   * Gets the {@link this._visible}
   */
  get visible() {
    return this._visible;
  }
  setVisible(v) {
    runInAction(() => {
      this._visible = v;
    });
  }

  /**
   * Glyph to be shown with this item.
   */

  /**
   * Get viewer on which this item should be visible. If undefined item will be visible in both viewers.
   */

  /**
   * What should happen after clicking on this item.
   */
}, _defineProperty(_CompositeBarItemController, "id", void 0), _CompositeBarItemController), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_disabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_collapsed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_active", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_pinned", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_visible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);